module.exports = __webpack_public_path__ + "static/img/icon.d8043f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon.png
// module id = 54
// module chunks = 1